var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-main-collection k-standards-home-wrapper"},[(_vm.iframe_rendered)?_c('iframe',{staticClass:"k-standards-home-iframe",attrs:{"name":"satchel_tab_iframe","src":_vm.iframe_src}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }